import Vue from 'vue'
import VueRouter from "vue-router";

import Warboard from "@/Warboard";
import {store} from './store/index.js'

import 'popper.js'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './assets/styles/custom.scss'

// Font Awesome Icons
import { library } from "@fortawesome/fontawesome-svg-core";
import { faUser, faSync, faCheck, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faUser, faSync, faCheck, faToggleOn, faToggleOff);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// No Clue
Vue.config.productionTip = false;

// Vue Router Initialization
Vue.use(VueRouter);
import routes from './routes'
const warboard_router = new VueRouter({routes, mode: 'history'});
warboard_router.beforeEach(((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.loggedIn === false) {
      next({name: 'login'})
    } else {
      next()
    }
  } else {
    next()
  }
}));

// Vue initialization
new Vue({
  render: h => h(Warboard),
  store: store,
  components: { Warboard },
  template: '<Warboard/>',
  router: warboard_router,
  mounted: () => {
    if(store.getters.loggedIn){

      // Todo: Use store tryRefresh function for this

      store.dispatch('obtainUserDetails').catch(e => {

        // eslint-disable-next-line no-console
        console.log('Obtain User Details did not return: ' + e.response.statusText);

        store.dispatch('refreshToken').then((response) => {

          // eslint-disable-next-line no-console
          console.log(response);

          store.dispatch('obtainUserDetails').catch(e => {
            // eslint-disable-next-line no-console
            console.log('Wtf: ');
            // eslint-disable-next-line no-console
            console.log(e);
            store.commit('set_logged_in', false);
            warboard_router.push({name: 'login'});
          })

        }).catch(e => {

          // eslint-disable-next-line no-console
          console.log('Refresh Token did not return');
          // eslint-disable-next-line no-console
          console.log(e);
          store.commit('set_logged_in', false);

        });

      });

      store.dispatch('tryRefresh', {action: 'obtainProjectManagerList', data: null});

      store.dispatch('tryRefresh', {action: 'obtainTeamList', data: null})

    }
  },
}).$mount('#app');
